import React from 'react';

import {
    withStyles,
    ListItem,
    Typography,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Divider,
    Grid,
    Switch,
} from '@material-ui/core';

import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import AppData from '../../model/AppData';
import MBack from '../view/MBack';

const SecretSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: theme.palette.secondary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.secondary.main,
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

class SelfSecret extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nickname: AppData.me.Username,
        };
        this._onItemClick = this._onItemClick.bind(this);
    }

    _onItemClick(idx) {

    }

    // 个人信息
    render() {
        const { classes } = this.props;
        return (
            <MBack title="隐私保护">
                <ListItem disableRipple className={classes.root} button onClick={() => this._onItemClick(0)}>
                    <ListItemText primary={<Typography className={classes.listText} >使用手势密码登录</Typography>} />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete">
                            <SecretSwitch />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid style={{ height: 6 }}></Grid>
                <ListItem disableRipple className={classes.root} button onClick={() => this._onItemClick(1)}>
                    <ListItemText primary={<Typography className={classes.listText} >修改手势密码</Typography>} />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete">
                            <ChevronRightOutlinedIcon style={{ color: '#E2E2E2', fontSize: 20 }} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            </MBack>
        );
    }
}

export default withStyles((theme) => ({
    root: {
        backgroundColor: '#fff',
        height: 50,
    },
    listText: {
        color: theme.palette.common.default,
        fontSize: theme.typography.pxToRem(14),
    }

}))(SelfSecret);